export default function splash() {
    if (document.querySelector(".splash")) {
        let splash = document.querySelector(".splash");

        window.onload = function() {
            splash.classList.add("is-loaded");
        };
    }
}
